import type { BulkOnboardSession } from "./BulkOnboardSession";

const SESSION_KEY = "bulkOnboardingSession";

export const getBulkOnboardSession = (): BulkOnboardSession | null => {
    const sessionStr = sessionStorage.getItem(SESSION_KEY);
    if (!sessionStr) return null;
    try {
        return JSON.parse(sessionStr);
    } catch {
        return null;
    }
};

export const setBulkOnboardSession = (session: BulkOnboardSession) => {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const removePropertiesFromSession = (propertyIds: string[], onboardingIds: string[]) => {
    const session = getBulkOnboardSession();
    if (!session) return;

    session.properties = session.properties.filter(
        (p) => !propertyIds.includes(p.propertyId) && (!p.onboardingId || !onboardingIds.includes(p.onboardingId)),
    );

    setBulkOnboardSession(session);
};
